import { apiAction, apiFetch, getMetaContent } from '../utils';
import PageableDuck from './PageableDuck';

const duck = new PageableDuck('lotteryConfigurations');

const test = configurationId => {
  const token = getMetaContent('csrf-token')
  const headers = { Accept: 'application/json', 'X-CSRF-Token': token }

  return (
    apiAction(
      duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
      state => (
        apiFetch.post(
          state,
          `lottery_configurations/${configurationId}/test`,
          null,
          { headers }
        )
      )
    )
  )
}

const run = configurationId => {
  const token = getMetaContent('csrf-token')
  const headers = { Accept: 'application/json', 'X-CSRF-Token': token }

  return (
    apiAction(
      duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
      state => (
        apiFetch.post(
          state,
          `lottery_configurations/${configurationId}/run`,
          null,
          { headers }
        )
      )
    )
  )
}

const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    test,
    run
  }
}

const reducer = duck.reducer;
export {reducer as default, entity};
